var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    width: "0.75em",
    height: "0.75em",
    preserveAspectRatio: "xMidYMid meet",
    className: "",
    style: {
      verticalAlign: "middle",
      color: "rgb(87, 142, 224)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.276 1.295a6 6 0 0 0 3.148 10.678.75.75 0 0 0 .298.02A6 6 0 1 0 2.333 1.25l-.035-.012a4.22 4.22 0 0 0-.022.058ZM2.15 3.67a4.502 4.502 0 0 0 2.52 6.63 2.25 2.25 0 0 0-.512-1.033l-.416-.477c-.74-.844-.663-2.008-.04-2.768A4.154 4.154 0 0 1 2.15 3.67Zm1.428-1.463c-.165.876.127 1.77.75 2.38a2.025 2.025 0 0 1 1.738-1.41 1.818 1.818 0 0 0 1.567-1.31l.016-.055A4.488 4.488 0 0 0 6 1.5c-.892 0-1.723.26-2.422.707Zm5.383.404A3.318 3.318 0 0 1 6.215 4.67a.535.535 0 0 0-.48.58h1.553c1.798 0 2.843 2.032 1.799 3.494-.175.245-.37.474-.582.687l-.687.687A4.501 4.501 0 0 0 8.961 2.61ZM5.303 6.75l-.044.006a.635.635 0 0 0-.388 1.047l.416.476c.37.422.639.92.79 1.459L7.444 8.37c.154-.154.295-.32.422-.498a.71.71 0 0 0-.578-1.122H5.303Z",
    fill: "currentcolor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeicon);
export default __webpack_public_path__ + "static/media/globeicon.5149e6ed86aaf4e14682d8d717a37cd8.svg";
export { ForwardRef as ReactComponent };